import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Grid, Card } from 'semantic-ui-react';
import { convertFromHTML, convertToHTML } from 'draft-convert';
import _ from 'lodash';
import InputsSection from './InputsSection';
import TextEditor from '../../TextEditor';
import { EditorState, RichUtils, ContentState } from 'draft-js';
import FNButtons from '../FNButtons';
import compositeDecorator from './Decorator';
import { renderMoreReadableName } from '../renderMoreReadableName';
import {
  htmlToStyle,
  styleToHTML,
  htmlToBlock,
  blockToHTML
} from './customStyles';

class Section extends React.Component {
  state = {
    editorState: EditorState.createEmpty(compositeDecorator),
    content: 'createNotice'
  };

  componentDidMount() {
    this.replaceEditorContent();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentStage !== this.props.currentStage ||
      nextProps.template !== this.props.template
    ) {
      this.replaceEditorContent(nextProps.template);
    }
  }

  onEditorChange = editorState => {
    this.setState({ editorState });
  };

  toggleBlockType = blockType => {
    const { editorState } = this.state;
    this.onEditorChange(RichUtils.toggleBlockType(editorState, blockType));
  };
  toggleInlineStyle = style => {
    const { editorState } = this.state;
    this.onEditorChange(RichUtils.toggleInlineStyle(editorState, style));
  };

  clearAllText = () => {
    const editorState = EditorState.push(
      this.state.editorState,
      ContentState.createFromText('')
    );
    this.setState({ editorState });
  };

  replaceEditorContent = newTemplateContent => {
    const { editorState } = this.state;
    const { template } = this.props;
    const contentState = convertFromHTML({
      htmlToStyle,
      htmlToBlock
    })(newTemplateContent || template);

    const nextEditorState = EditorState.push(editorState, contentState);
    this.clearAllText();
    this.onEditorChange(nextEditorState);
  };

  handleInputChange = (e, { value, id }) =>
    this.props.onTemplateInputChange(value, id);

  handleDateChange = (date, id) =>
    this.props.onTemplateInputChange(
      moment(date).format('YYYY-MM-DDTHH:mm:ss'),
      id
    );

  onNext = () => {
    const { navButtonsProps } = this.props;
    const { editorState } = this.state;
    const html = convertToHTML({
      styleToHTML,
      blockToHTML
    })(editorState.getCurrentContent());
    if (html) {
      navButtonsProps.onNext(html);
    }
  };

  render = () => {
    const {
      navButtonsProps,
      fullPaxFieldsData,
      sectionFields,
      language,
      currentSection
    } = this.props;
    const { editorState } = this.state;
    const currentSectionPaxData =
      fullPaxFieldsData && sectionFields
        ? sectionFields
            .map(label => ({
              ..._.find(fullPaxFieldsData, ['id', label])
            }))
            .filter(element => element)
        : [];

    return (
      <React.Fragment>
        <Card.Description>
          <Grid>
            <Grid.Row>
              <Grid.Column width={4}>
                <div style={{ color: 'black', fontSize: 16 }}>
                  {renderMoreReadableName(currentSection)}
                </div>
                <InputsSection
                  language={language}
                  currentSectionPaxData={currentSectionPaxData}
                  onInputChange={this.handleInputChange}
                  onDateChange={this.handleDateChange}
                />
              </Grid.Column>
              <Grid.Column width={12}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <TextEditor
                        editorState={editorState}
                        toggleInlineStyle={this.toggleInlineStyle}
                        toggleBlockType={this.toggleBlockType}
                        onEditorChange={this.onEditorChange}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
        <FNButtons {...navButtonsProps} onNext={this.onNext} />
      </React.Fragment>
    );
  };
}

const mapStateToProps = ({ formalNotice, courtApplication }, { taskType }) => {
  const taskName = taskType === 'LFN' ? formalNotice : courtApplication;
  const { options, currentSection } = taskName;
  return {
    currentSection,
    language: options && options.languageOption
  };
};

export default connect(mapStateToProps)(Section);



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Section/index.js